require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.7@core-js/library/fn/get-iterator.js
// module id = 599
// module chunks = 1